module.exports = __webpack_public_path__ + "assets/img/icon-triangle-down.3ac901b1.png";